import React from 'react'
import './Screen.scss'

const Screen = props => {
    return (
        <div className={`Screen`}>
            <div className={`current-screen`}>
                <img src={props.source} alt={props.alt || 'software screen content'}/>
            </div>
            <div className={`next-screen`}>
                <img src={props.nextSource} alt={'preload of next screen'}/>
            </div>
        </div>
    )
}

export default Screen